const handleIdsProductsTooltips = (function (jQuery) {

  var init = function () {
    var tooltips = jQuery('.tip-ids-products');
    if (tooltips.length === 0) {
      return;
    }

    jQuery('body').on('click', function (e) {
      tooltips.each(function () {
        if (
          !jQuery(this).is(e.target) &&
          jQuery(this).has(e.target).length === 0 &&
          jQuery('.tooltip').has(e.target).length === 0
        ) {
          jQuery(this).tooltip('hide');
        }
      });
    });

    tooltips.each(function () {
      jQuery(this).tooltip({
        trigger: 'click',
        container: 'body',
        position: 'right',
        html: true,
        title: jQuery('#' + jQuery(this).data('tip')).html()
      })
        .on('inserted.bs.tooltip', function () {
          var $self = jQuery(this);
          $self.find('i').removeClass('text-primary').addClass('text-secondary');
          handleFnacTooltip(jQuery('#' + jQuery(this).attr('aria-describedby')))
        })
        .on('hidden.bs.tooltip', function () {
          var $self = jQuery(this);
          $self.find('i').removeClass('text-secondary').addClass('text-primary');
        });
    });
  }

  var handleFnacTooltip = function ($tooltip) {
    var $link = $tooltip.find('a.scroll-to-id-fnac');
    if ($link.length === 0) {
      return;
    }
    var $target = $tooltip.find('.scroll-to-id-fnac');
    var $targetContainer = $tooltip.find('.url-example-fnac');
    $link.click(function () {
      $targetContainer.animate({
        scrollLeft: $target.offset().left
      }, 2000);
    });
  };

  jQuery(function () {
    init();
  })

})(jQuery);
